import $ from 'jquery';
var jQuery = $;

export var wg_modal = {
    THROBBER_CLASS: 'wg-modal__throbber',
    THROBBER_SELECTOR: '.wg-modal__throbber',
    FIXED_CLASS: 'wg-modal__fixed',
};

var CANCEL_BUTTON_SELECTOR = '.js-wg-modal_button__cancel';
var DISABLED_BUTTON_CLASS = 'forms_button__disabled';
var MODAL_CLASS = 'wg-modal';
var OUTER_CLASS = 'wg-modal_outer';
var INNER_CLASS = 'wg-modal_inner';
var LAYOUT_SELECTOR = '.js-layout';
var THROBBER_ATTACHED_CLASS = 'throbber-attached';
var XBOX_RETURN_URL_SELECTOR = '.js-xbox-select';
var PS4_RETURN_URL_SELECTOR = '.js-ps4-select';
var PLATFORM_SELECT_TITLE_SELECTOR = '.platformselect_block_title';

var $body;
var $layout;
var $window = $(window);

$(function () {
    $body = $('body');
    $layout = $(LAYOUT_SELECTOR);
});

var confirmUnload = function () {
    return gettext("An operation is in progress.")
};
var disableBodyScroll = function () {
    if ($layout.length > 0) {
        var scrollTop = $body.scrollTop();
        $layout.css({overflow: 'hidden'});
        $layout.scrollTop(scrollTop);
        $body.css({'overflow-y': 'scroll'});
    }
    else
        $body.css({overflow: 'hidden'});
};

var enableBodyScroll = function () {
    if ($layout.length > 0) {
        var scrollTop = $layout.scrollTop();
        $layout.css({overflow: 'visible'});
        $body.css({'overflow-y': 'auto'});
        if (scrollTop != 0)
            $body.scrollTop(scrollTop);
    }
    else
        $body.css({overflow: 'auto'});
};

wg_modal.disableUnloadBlock = function () {
    $window.off("beforeunload", confirmUnload);
};

wg_modal.showLogIn = function (title, redirectBreadcrumbs) {
    var $loginOptions = $('.js-login-options');

    if (!redirectBreadcrumbs)
        redirectBreadcrumbs = '';

    $loginOptions.find(PLATFORM_SELECT_TITLE_SELECTOR).html(title);
    $loginOptions.find(XBOX_RETURN_URL_SELECTOR).attr('href', (window.XBOX_LOGIN_URL + encodeURIComponent(redirectBreadcrumbs)));
    $loginOptions.find(PS4_RETURN_URL_SELECTOR).attr('href', (window.PS4_LOGIN_URL + encodeURIComponent(redirectBreadcrumbs)));

    $loginOptions.showAsModal({
        dismissible: true,
        createClone: true
    });
};

wg_modal.createAlertBlock = function (title, contents, buttons) {
    var $div = $('<div>');
    $div.append($('<h1>').text(title));
    $div.append(contents);

    var $buttons = $('<div>').addClass('forms_command-bar');
    $buttons.append(buttons);
    $div.append($buttons);

    return $div;
};

wg_modal.showAlert = function (title, contents) {

    var $modal;
    var $okayButton = $('<a>').addClass('forms_button').text(gettext('OK'));

    $okayButton.on('click tap', function () {
        $modal.close();
    });

    var $div = wg_modal.createAlertBlock(title, contents, $okayButton);
    $modal = $div.showAsModal({
        dismissible: true,
        disposable:true,
    });
};

wg_modal.showConfirm = function (title, contents, verb, confirmHandler, dismissHandler) {

    var $modal;
    var $actionButton = $('<a>').addClass('forms_button js-forms_button__action').text(verb);
    var $cancelButton = $('<a>').addClass('forms_button js-forms_button__cancel').text(gettext('Cancel'));

    $actionButton.on('click tap', function () {
        if (!$(this).hasClass(DISABLED_BUTTON_CLASS)) {
            $modal.close();
            wg_modal.showThrobber();
            confirmHandler();
        }
    });
    $cancelButton.on('click tap', function () {
        $modal.close();
        dismissHandler();
    });

    var $div = wg_modal.createAlertBlock(title, contents, [$actionButton, $cancelButton]);
    $modal = $div.showAsModal({
        dismissible: true,
        disposable:true,
        onClose:dismissHandler,
    });
};

wg_modal.hideThrobber = function ($container) {
    $window.off("beforeunload", confirmUnload);
    if (!$container) {
        $container = $body;
        enableBodyScroll();
    }

    $container.removeClass(THROBBER_ATTACHED_CLASS).find(wg_modal.THROBBER_SELECTOR).remove();
};
wg_modal.showThrobber = function ($container, passive) {
    wg_modal.hideThrobber($container);

    if (!passive)
        $window.on("beforeunload", confirmUnload);

    var $message = $('<p>').html("&nbsp;&nbsp;&nbsp;" + gettext('One moment...'));
    var $throbber = $('<div>').addClass(wg_modal.THROBBER_CLASS).addClass(MODAL_CLASS);
    $throbber.append($message);

    if ($container) {
        $throbber.appendTo($container.addClass(THROBBER_ATTACHED_CLASS))
    } else {
        disableBodyScroll();
        $throbber.addClass(wg_modal.FIXED_CLASS).appendTo($body);
    }

    return $throbber;
};

$.fn.showAsModal = function (options) {

    var dismissible = options.dismissible;
    var onClose = options.onClose;
    var createClone = options.createClone;
    var disposable = options.disposable;

    if (createClone && disposable)
        throw "Modal cannot be both a clone and disposable";

    var $target = this;

    if (createClone && $target.parents().last().is(document.documentElement))
        $target = $target.clone(true);

    $target.css({display: 'inline-block'});

    var $modal = $('<div>')
        .addClass(MODAL_CLASS).addClass(wg_modal.FIXED_CLASS)
        .data('dismissible', dismissible);
    var $outer = $('<div>').addClass(OUTER_CLASS);
    var $inner = $('<div>').addClass(INNER_CLASS);
    disableBodyScroll();


    $modal.close = function () {
        if (!onClose || onClose() !== false) {
            enableBodyScroll();
            if (createClone || disposable)
                $modal.remove();
            else
                $modal.hide();
        }
    };

    $modal.add(CANCEL_BUTTON_SELECTOR).on('click tap', function (ev) {
        var $this = $(this);
        var $target = $(ev.target);

        var buttonClicked = $target.is(CANCEL_BUTTON_SELECTOR);

        if (buttonClicked ||
            ($this.data('dismissible') &&
            (ev.target == $modal.get(0) || ev.target == $inner.get(0)))) {

            $modal.close();

        }
    });

    $inner.append($target);
    $outer.append($inner);
    $modal.append($outer);
    $body.append($modal);
    injectSVGs();
    return $modal;
};
